// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"49":"f3dc1878","956":"374dde72","998":"00ecf029"}[chunkId] + ".css";
};